import { Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface IProps {
  title: string;
  onClose: Function;
}

function EventCompletionInfoHeader({ title, onClose }: IProps) {
  return (
    <Box
      sx={{
        backgroundColor: 'background.default',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: {
          xs: '28px 16px 20px 16px',
          md: '28px 24px 20px 24px',
        },
      }}
    >
      <Typography variant='h2' color='primary.dark' sx={{ margin: 0 }}>
        {title}
      </Typography>
      <CloseIcon
        onClick={() => onClose()}
        sx={{ height: 32, width: 32, cursor: 'pointer' }}
        color='primary'
      />
    </Box>
  );
}

export default EventCompletionInfoHeader;
